import ImageIcon from '@mui/icons-material/Image';
import { Avatar, AvatarProps } from '@mui/material';
import { FC } from 'react';

export const Image: FC<AvatarProps> = props => {
	return (
		<Avatar variant="square" {...props}>
			<ImageIcon />
		</Avatar>
	);
};
